import { render, staticRenderFns } from "./PlacementsEndComponentPerformance.vue?vue&type=template&id=b0deab3a&"
import script from "./PlacementsEndComponentPerformance.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports